module.exports = __webpack_public_path__ + "img/avatar5.1534edb9.png";